import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./pages/Main";
import About from './pages/About'
import Impression from './pages/Impression'
import Assessment from './pages/Assessment'
import Result from './pages/Result'
import Error404 from './pages/Errer404'
import '../src/assets/css/style.css'
import '../src/assets/css/animation.css'
import ScrollTop from './components/ScrollTop'


const App = () => {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path={`/nanineko`} element={<Main />} />
        <Route path={`/nanineko/about/`} element={<About />} />
        <Route path={`/nanineko/impression/`} element={<Impression />} />
        <Route path={`/nanineko/assessment/`} element={<Assessment />} />
        <Route path={`/nanineko/result/`} element={<Result />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
